import { apiClient } from './apiClient';

const asList = (data) => data?.results || data || [];

const detencionesService = {
  listar: async (params = {}) => {
    const response = await apiClient.get('/detenciones-equipos/', { params });
    return response.data;
  },

  obtener: async (id) => {
    const response = await apiClient.get(`/detenciones-equipos/${id}/`);
    return response.data;
  },

  crear: async (payload) => {
    const response = await apiClient.post('/detenciones-equipos/', payload);
    return response.data;
  },

  actualizar: async (id, payload) => {
    const response = await apiClient.put(`/detenciones-equipos/${id}/`, payload);
    return response.data;
  },

  eliminar: async (id) => {
    await apiClient.delete(`/detenciones-equipos/${id}/`);
  },

  egresar: async (id, payload = {}) => {
    const response = await apiClient.post(`/detenciones-equipos/${id}/egresar/`, payload);
    return response.data;
  },

  reabrir: async (id) => {
    const response = await apiClient.post(`/detenciones-equipos/${id}/reabrir/`);
    return response.data;
  },

  listarSimple: async (params = {}) => {
    const response = await apiClient.get('/detenciones-equipos/', { params });
    return asList(response.data);
  },
};

export default detencionesService;
